var map = {
	"./crypto-pending.png": 1888,
	"./crypto-reject.png": 1889,
	"./crypto-success.png": 1890,
	"./direpay.svg": 1891,
	"./trx.svg": 1892,
	"./usdc.svg": 1893,
	"./usdt.svg": 1894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;